/* @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Typography, Typography2, useTheme } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';
import type { CSSProperties } from '@coursera/coursera-ui';

import type { CommunityStatsFragment } from 'bundles/professional-certificate-category-pages/__generated__/contentfulTypes';

const styles: Record<string, CSSProperties> = {
  statsInfoCard: (theme: Theme) => ({
    height: 278,
    minHeight: 242,
    margin: 'var(--cds-spacing-100) var(--cds-spacing-50)',
    padding: 'var(--cds-spacing-200)',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--cds-color-blue-50)',
  }),
  description: {
    lineHeight: '1rem',
  },
  highlightLabel: (theme: Theme) => ({
    marginBottom: 'var(--cds-spacing-100)',
  }),
};

const CommunityStats = ({ highlightLabel, highlightStats }: CommunityStatsFragment) => {
  const theme = useTheme();

  return (
    <div css={styles.statsInfoCard(theme)}>
      <div>
        <Typography2 variant="bodyPrimary" component="p" css={styles.highlightLabel(theme)}>
          <strong>{highlightLabel}</strong>
        </Typography2>
        {/* eslint-disable-next-line @coursera-web/custom-rules/prefer-cds-typography2 -- FIXME: legacy; migrate to Typography2 */}
        <Typography variant="d2semibold" component="p" css={styles.description}>
          <strong>{highlightStats}</strong>
        </Typography>
      </div>
    </div>
  );
};

export default CommunityStats;
